// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/framework/PageLoading/index';

export function getRoutes() {
  const routes = [
  {
    "path": "/user",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__framework__layouts__UserLayout' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/components/framework/layouts/UserLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/user/",
        "redirect": "/user/login",
        "exact": true
      },
      {
        "name": "login",
        "path": "/user/login",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__administration__login' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/administration/login'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  },
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__framework__layouts__SecurityLayout' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/components/framework/layouts/SecurityLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__framework__layouts__BasicLayout' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/components/framework/layouts/BasicLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/",
            "redirect": "/administration",
            "exact": true
          },
          {
            "name": "管理",
            "path": "/administration",
            "icon": "setting",
            "exact": false,
            "authority": [
              "Admin",
              "Operation Department"
            ],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__administration__akms' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/administration/akms'), loading: LoadingComponent}),
            "routes": [
              {
                "path": "/administration",
                "redirect": "/administration/user",
                "title": "管理",
                "exact": true
              },
              {
                "name": "用户组列表",
                "title": "用户组列表",
                "path": "/administration/userGroup",
                "authority": [
                  "Admin"
                ],
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__administration__akms__UserGroup' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/administration/akms/UserGroup'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "用户权限列表",
                "title": "用户权限列表",
                "path": "/administration/groupPermission",
                "authority": [
                  "Admin"
                ],
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__administration__akms__GroupPermission' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/administration/akms/GroupPermission'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "用户列表",
                "title": "用户列表",
                "path": "/administration/user",
                "authority": [
                  "Admin"
                ],
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__administration__akms__user' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/administration/akms/user'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "注册账户",
                "title": "注册账户",
                "path": "/administration/register",
                "authority": [
                  "Admin"
                ],
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__administration__register' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/administration/register'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "添加OE Token",
                "title": "添加OE Token",
                "path": "/administration/oeToken",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__administration__akms__OeToken' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/administration/akms/OeToken'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "代理列表",
                "title": "代理列表",
                "path": "/administration/agency",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__administration__akms__AgencyList' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/administration/akms/AgencyList'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "FB开户进度",
            "title": "FB开户进度",
            "path": "/fbProcess",
            "icon": "audit",
            "authority": [
              "Operation Department",
              "Account Executive",
              "BVT Account Executive",
              "Madhouse",
              "Game Operation Department"
            ],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__FbProcess' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/FbProcess'), loading: LoadingComponent}),
            "routes": [
              {
                "path": "/fbProcess",
                "redirect": "/fbProcess/total",
                "title": "FB开户进度",
                "exact": true
              },
              {
                "name": "FB全量开户",
                "title": "FB全量开户",
                "path": "/fbProcess/total",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__FbProcess__Total' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/FbProcess/Total'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "FB开户审核",
                "title": "FB开户审核",
                "path": "/fbProcess/review",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__FbProcess__Review' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/FbProcess/Review'), loading: LoadingComponent}),
                "authority": [
                  "Operation Department",
                  "Game Operation Department"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "Google开户进度",
            "title": "Google开户进度",
            "path": "/googleProcess",
            "icon": "audit",
            "authority": [
              "Operation Department",
              "Account Executive",
              "BVT Account Executive"
            ],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__GoogleProcess' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/GoogleProcess'), loading: LoadingComponent}),
            "routes": [
              {
                "path": "/googleProcess",
                "redirect": "/googleProcess/total",
                "title": "Google开户进度",
                "exact": true
              },
              {
                "name": "Google全量开户",
                "title": "Google全量开户",
                "path": "/googleProcess/total",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__GoogleProcess__Total' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/GoogleProcess/Total'), loading: LoadingComponent}),
                "authority": [
                  "Account Executive",
                  "BVT Account Executive"
                ],
                "exact": true
              },
              {
                "name": "Google开户审核",
                "title": "Google开户审核",
                "path": "/googleProcess/review",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__GoogleProcess__Review' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/GoogleProcess/Review'), loading: LoadingComponent}),
                "authority": [
                  "Operation Department"
                ],
                "exact": true
              },
              {
                "name": "Mcc维护",
                "title": "Mcc维护",
                "path": "/googleProcess/mcc",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__GoogleProcess__Mcc' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/GoogleProcess/Mcc'), loading: LoadingComponent}),
                "authority": [
                  "Operation Department"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "FB批处理",
            "path": "/fbBatch",
            "icon": "unorderedList",
            "authority": [
              "Madhouse",
              "Operation Department",
              "Game Operation Department"
            ],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BatchProcessing__FbBatch' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/BatchProcessing/FbBatch'), loading: LoadingComponent}),
            "routes": [
              {
                "path": "/fbBatch",
                "redirect": "/fbBatch/recharge",
                "title": "FB批处理",
                "exact": true
              },
              {
                "name": "额度管理",
                "title": "额度管理",
                "path": "/fbBatch/recharge",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BatchProcessing__FbBatch__recharge' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/BatchProcessing/FbBatch/recharge'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "账户更名",
                "title": "账户更名",
                "path": "/fbBatch/rename",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BatchProcessing__FbBatch__rename' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/BatchProcessing/FbBatch/rename'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "权限管理",
                "title": "权限管理",
                "path": "/fbBatch/permission",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BatchProcessing__FbBatch__permission' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/BatchProcessing/FbBatch/permission'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "绑定BM",
                "title": "绑定BM",
                "path": "/fbBatch/bm",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BatchProcessing__FbBatch__bm' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/BatchProcessing/FbBatch/bm'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "像素绑定",
                "title": "像素绑定",
                "path": "/fbBatch/pixel",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BatchProcessing__FbBatch__pixel' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/BatchProcessing/FbBatch/pixel'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "Google批处理",
            "path": "/googleBatch",
            "icon": "unorderedList",
            "authority": [
              "Operation Department"
            ],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BatchProcessing__GoogleBatch' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/BatchProcessing/GoogleBatch'), loading: LoadingComponent}),
            "routes": [
              {
                "path": "/googleBatch",
                "redirect": "/googleBatch/recharge",
                "title": "Google批处理",
                "exact": true
              },
              {
                "name": "额度管理",
                "title": "额度管理",
                "path": "/googleBatch/recharge",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BatchProcessing__GoogleBatch__Recharge' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/BatchProcessing/GoogleBatch/Recharge'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "账户更名",
                "title": "账户更名",
                "path": "/googleBatch/rename",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BatchProcessing__GoogleBatch__Rename' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/BatchProcessing/GoogleBatch/Rename'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "授权个人账户",
                "title": "授权个人账户",
                "path": "/googleBatch/permission",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BatchProcessing__GoogleBatch__Permission' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/BatchProcessing/GoogleBatch/Permission'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "Mcc邀请",
                "title": "Mcc邀请",
                "path": "/googleBatch/invite",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BatchProcessing__GoogleBatch__Invite' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/BatchProcessing/GoogleBatch/Invite'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "Mcc转移",
                "title": "Mcc转移",
                "path": "/googleBatch/transfer",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BatchProcessing__GoogleBatch__Transfer' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/BatchProcessing/GoogleBatch/Transfer'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "账户检查",
            "path": "/check",
            "icon": "carryOut",
            "exact": false,
            "authority": [
              "Operation Department",
              "Account Executive",
              "BVT Account Executive",
              "SMB AE",
              "Game Operation Department"
            ],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AccountCheck' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/AccountCheck'), loading: LoadingComponent}),
            "routes": [
              {
                "path": "/check",
                "redirect": "/check/checking",
                "title": "账户检查",
                "exact": true
              },
              {
                "name": "检查账户",
                "title": "检查账户",
                "path": "/check/checking",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AccountCheck__Checking' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/AccountCheck/Checking'), loading: LoadingComponent}),
                "authority": [
                  "Operation Department",
                  "Game Operation Department"
                ],
                "exact": true
              },
              {
                "name": "违规账户",
                "title": "违规账户",
                "path": "/check/violation",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AccountCheck__Violation' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/AccountCheck/Violation'), loading: LoadingComponent}),
                "authority": [
                  "Operation Department",
                  "Game Operation Department"
                ],
                "exact": true
              },
              {
                "name": "封停账户",
                "title": "封停账户",
                "path": "/check/closed",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AccountCheck__Closed' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/AccountCheck/Closed'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "封停账户白名单",
                "title": "封停账户白名单",
                "path": "/check/blocked-account-list",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AccountCheck__BlockedAccountWhitelist' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/AccountCheck/BlockedAccountWhitelist'), loading: LoadingComponent}),
                "authority": [
                  "Account Executive",
                  "BVT Account Executive",
                  "SMB AE"
                ],
                "exact": true
              },
              {
                "name": "封停签约白名单",
                "title": "封停签约白名单",
                "path": "/check/blocked-sign-list",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AccountCheck__BlockedSignWhitelist' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/AccountCheck/BlockedSignWhitelist'), loading: LoadingComponent}),
                "authority": [
                  "Account Executive",
                  "BVT Account Executive",
                  "SMB AE"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "分发邮件",
            "path": "/mail",
            "icon": "mail",
            "exact": false,
            "authority": [
              "Operation Department"
            ],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__DistributeMail' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/DistributeMail'), loading: LoadingComponent}),
            "routes": [
              {
                "path": "/mail",
                "redirect": "/mail/addressee",
                "title": "分发邮件",
                "exact": true
              },
              {
                "name": "收件人",
                "title": "收件人",
                "path": "/mail/addressee",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__DistributeMail__Addressee' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/DistributeMail/Addressee'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "被封申诉",
                "title": "被封申诉",
                "path": "/mail/appeal",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__DistributeMail__Appeal' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/DistributeMail/Appeal'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "Rad提醒",
                "title": "Rad提醒",
                "path": "/mail/reminder",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__DistributeMail__Reminder' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/DistributeMail/Reminder'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "Policy Insight",
            "path": "/policy",
            "icon": "carryOut",
            "exact": false,
            "authority": [
              "Operation Department"
            ],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PolicyInsight' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/PolicyInsight'), loading: LoadingComponent}),
            "routes": [
              {
                "path": "/policy",
                "redirect": "/policy/entity",
                "title": "Policy Insight",
                "exact": true
              },
              {
                "name": "黑名单",
                "title": "黑名单",
                "path": "/policy/blacklist",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PolicyInsight__Blacklist' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/PolicyInsight/Blacklist'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "开户主体消耗",
                "title": "开户主体消耗",
                "path": "/policy/spend",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PolicyInsight__EntitySpend' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/PolicyInsight/EntitySpend'), loading: LoadingComponent}),
                "authority": [
                  "Operation Department"
                ],
                "exact": true
              }
            ]
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/404'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/404'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  },
  {
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/pages/404'), loading: LoadingComponent}),
    "exact": true
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
